export default __webpack_public_path__ + "static/media/Opprettelse av Idegeneratoren ved UIT.8d34084c.pdf";